// import React, { use, useEffect, useState } from "react";
// import { Container, Row, Col, Card, Button } from "react-bootstrap";
// import "./../../assets/css/BlogLandingPage.css";
// import axios from "axios";
// import BASE_URL from "../../component/commanfile";
// import { useNavigate } from "react-router-dom";

// const BlogLandingPage = () => {
//   const navigate = useNavigate();
//   console.log("process.env.PUBLIC_URL",process.env.PUBLIC_URL)
//   const allBlogs = [
//     {
//       blog_title: "Wonders of the Himalayas",
//       blog_short_discreption: "Explore breathtaking trails and snow-covered peaks in this Himalayan adventure.",
//       blog_type: "Adventure",
//       blog_thumbnail:  `https://picsum.photos/id/2/800/600`,
//       blog_image: "",
//     },
//     {
//       blog_title: "Romantic Venice Escapade",
//       blog_short_discreption: "Glide through canals and enjoy timeless Italian romance in Venice.",
//       blog_type: "Romantic",
//       blog_thumbnail: "https://picsum.photos/id/1/800/600",
//       blog_image: "",
//     },
//     {
//       blog_title: "Safari in Kenya",
//       blog_short_discreption: "Experience the thrill of the wild with an unforgettable African safari.",
//       blog_type: "Wildlife",
//       blog_thumbnail: "https://picsum.photos/id/10/800/600",
//       blog_image: "",
//     },
//     {
//       blog_title: "Paris City Lights",
//       blog_short_discreption: "Fall in love with the city of lights, romance, and croissants.",
//       blog_type: "City",
//       blog_thumbnail: "https://picsum.photos/id/100/800/600",
//       blog_image: "",
//     },
//     {
//       blog_title: "Exploring the Amazon",
//       blog_short_discreption: "Venture deep into the lush rainforest and discover exotic creatures.",
//       blog_type: "Adventure",
//       blog_thumbnail: "https://picsum.photos/id/1000/800/600",
//       blog_image: "",
//     },
//     {
//       blog_title: "Beaches of Bali",
//       blog_short_discreption: "Soak up the sun, waves, and serene vibes on Bali’s finest beaches.",
//       blog_type: "Relaxation",
//       blog_thumbnail: "https://picsum.photos/id/12/800/600",
//       blog_image: "",
//     },
//     {
//       blog_title: "Tokyo Nights",
//       blog_short_discreption: "Discover the futuristic lights and timeless traditions of Tokyo.",
//       blog_type: "City",
//       blog_thumbnail: "https://picsum.photos/id/14/800/600",
//            blog_image: "",
//     },
//     {
//       blog_title: "Road Trip through New Zealand",
//       blog_short_discreption: "From glaciers to beaches, explore the diverse landscapes of NZ.",
//       blog_type: "Road Trip",
//       blog_thumbnail: "https://picsum.photos/id/27/800/600",
//       blog_image: "",
//     },
//     {
//       blog_title: "Northern Lights in Norway",
//       blog_short_discreption: "Witness one of nature’s most stunning light shows in the arctic skies.",
//       blog_type: "Nature",
//       blog_thumbnail: "https://picsum.photos/id/19/800/600",
//       blog_image: "",
//     },
//     {
//       blog_title: "Desert Safari Dubai",
//       blog_short_discreption: "Ride the dunes, watch belly dancing, and enjoy Arabian nights in the desert.",
//       blog_type: "Desert",
//       blog_thumbnail: "https://picsum.photos/id/12/800/600",
//       blog_image: "",
//     },
//   ];
//   const [blogData, setBlogData] = useState([]); 

//   const [showAll, setShowAll] = useState(false);
//   const visibleBlogs = showAll ? blogData : blogData?.slice(0, 9);


//   useEffect(() => {
//     // Fetch gallery data from API
//     const fetchGalleryData = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}api/blogs`);
//         setBlogData(response?.data);
//       } catch (error) {
//         console.error("Error fetching gallery data:", error);
//       }
//     };

//     fetchGalleryData();
//   }, []);

//   return (
//     <div>
//       {/* Hero Section with First Blog Image */}
//       <div
//         className="hero-banner d-flex align-items-center justify-content-center text-white fw-bold"
//         style={{
//           // backgroundImage: `url(${blogData?.[0]?.blogImageBase64})`,
//           backgroundImage:`url(${BASE_URL}/api/image?file=${encodeURIComponent(blogData?.[0]?.blogImage)}`,

     
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           height: "400px",
//         }}
//       >
//         <h1>Our Blogs</h1>
//       </div>

//       <Container className="mt-5">
//         <h4 className="fw-bold mb-4">Our Blogs</h4>
//         <Row xs={1} sm={2} md={3} className="g-4">
//           {visibleBlogs?.map((blog, index) => (
//             <Col key={index}>
//               <Card className="h-100 border-0 shadow-sm blog-card"
//               onClick={() => navigate(`/blog/${blog.id}`)}
//               >
//                 <img
//                   variant="top"
//                   // src={blog.thumbnailBase64}
//                   src={`${BASE_URL}/api/image?file=${encodeURIComponent(blog?.thumbnail)}`}
//                   alt={blog.title}
//                   className="blog-image"
//                 />
//                 <Card.Body>
//                   <Card.Title className="fs-6 fw-bold">{blog.title}</Card.Title>
//                   <Card.Text className="text-muted" style={{ fontSize: "0.85rem" }}>
//                     {blog?.shortDescription?.slice(0, 120)}...
//                   </Card.Text>
//                   <span className="text-primary fw-semibold" style={{ fontSize: "0.85rem" }}>
//                     KNOW MORE
//                   </span>
//                 </Card.Body>
//               </Card>
//             </Col>
//           ))}
//         </Row>

//         {/* See More Button */}
//         {blogData?.length > 9 && (
//           <div className="text-center mt-4 mb-4">
//             <Button variant="primary" onClick={() => setShowAll(!showAll)}>
//               {showAll ? "Show Less" : "See More"}
//             </Button>
//           </div>
//         )}
//       </Container>
//     </div>
//   );
// };

// export default BlogLandingPage;


import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../component/commanfile";

const BlogLandingPage = () => {
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const visibleBlogs = showAll ? blogData : blogData?.slice(0, 9);

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/blogs`);
        setBlogData(response?.data);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };
    fetchGalleryData();
  }, []);

  const styles = {
    hero: {
      position: "relative",
      height: "500px",
      backgroundImage: blogData?.[0] 
        ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.7)), url(${BASE_URL}/api/image?file=${encodeURIComponent(blogData[0].blogImage)})`
        : "linear-gradient(45deg, #8f0909, #1a1a1a)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#white",
      textAlign: "center",
      borderRadius: "0 0 50px 50px"
    },
    blogCard: {
      borderRadius: "20px",
      overflow: "hidden",
      border: "none",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      cursor: "pointer",
      backgroundColor: "#fff",
      boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
    },
    imageContainer: {
      height: "240px",
      overflow: "hidden",
      position: "relative"
    },
    categoryBadge: {
      position: "absolute",
      top: "15px",
      left: "15px",
      backgroundColor: "rgba(143, 9, 9, 0.9)",
      backdropFilter: "blur(5px)",
      fontSize: "0.75rem",
      padding: "6px 12px"
    }
  };

  return (
    <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      {/* 1. MODERN HERO WITH OVERLAY */}
      <div style={styles.hero} className="text-white shadow-lg">
        <Container>
          <Badge bg="light" text="dark" className="mb-3 px-3 py-2 text-uppercase fw-bold">Travel Journal</Badge>
          <h1 style={{ fontSize: "4.5rem", fontWeight: "900", letterSpacing: "-2px" }}>Our Stories</h1>
          <p style={{ fontSize: "1.2rem", maxWidth: "600px", margin: "0 auto", opacity: 0.9 }}>
            Explore hidden gems, travel tips, and cultural wonders through the eyes of our experts.
          </p>
        </Container>
      </div>

      <Container className="py-5">
        {/* 2. SECTION HEADER */}
        <div className="d-flex justify-content-between align-items-end mb-5">
          <div>
            <h2 className="fw-bold mb-0" style={{ color: "#1a1a1a" }}>Latest Articles</h2>
            <div style={{ width: "50px", height: "4px", backgroundColor: "#8f0909", marginTop: "10px" }}></div>
          </div>
          <p className="text-muted d-none d-md-block">Total {blogData?.length} Stories found</p>
        </div>

        {/* 3. BLOG GRID */}
        <Row className="g-4">
          {visibleBlogs?.map((blog, index) => (
            <Col key={index} lg={4} md={6}>
              <Card 
                style={styles.blogCard} 
                className="h-100 hover-lift"
                onClick={() => navigate(`/blog/${blog.id}`)}
              >
                <div style={styles.imageContainer}>
                  <img
                    src={`${BASE_URL}/api/image?file=${encodeURIComponent(blog?.thumbnail)}`}
                    alt={blog.title}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                  {blog.type && (
                    <Badge pill style={styles.categoryBadge}>{blog.type}</Badge>
                  )}
                </div>
                
                <Card.Body className="p-4">
                  <div className="text-muted small mb-2 d-flex align-items-center">
                    <span>Admin</span>
                    <span className="mx-2">•</span>
                    <span>5 min read</span>
                  </div>
                  <Card.Title className="fw-bold mb-3" style={{ fontSize: "1.25rem", color: "#1a1a1a", lineHeight: "1.4" }}>
                    {blog.title}
                  </Card.Title>
                  <Card.Text className="text-muted mb-4" style={{ fontSize: "0.95rem" }}>
                    {blog?.shortDescription?.slice(0, 100)}...
                  </Card.Text>
                  
                  <div className="d-flex align-items-center fw-bold" style={{ color: "#8f0909", fontSize: "0.9rem" }}>
                    READ STORY <i className="bi bi-arrow-right ms-2"></i>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* 4. LOAD MORE ACTION */}
        {blogData?.length > 9 && (
          <div className="text-center mt-5 mb-5">
            <Button 
              size="lg"
              variant="outline-dark" 
              style={{ borderRadius: "100px", padding: "12px 40px", fontWeight: "600" }}
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? "VIEW LESS" : "EXPLORE ALL STORIES"}
            </Button>
          </div>
        )}
      </Container>

      {/* 5. ADD CUSTOM HOVER CSS */}
      <style>{`
        .hover-lift:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1) !important;
        }
        .hover-lift:hover img {
          transform: scale(1.05);
          transition: transform 0.5s ease;
        }
      `}</style>
    </div>
  );
};

export default BlogLandingPage;
